import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

import Select from "react-select";
import * as Yup from "yup";

import { useParams } from "react-router";
import config from "config.json";
import { toast } from 'react-toastify';

import { registerAccount } from "services/auth_service";
import { getAccountByUserId } from "services/user_service";
import { putAccount, getAccount } from "services/account_service";
import { createTeamHistory } from "services/teamhistory_service";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

import { useForm } from "react-hook-form";

import Manager from "components/definitions/roles-forms/Manager";
import Other from "components/definitions/roles-forms/Other";

import { Link } from "react-router-dom";

function App({ isReadOnly }) {
  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const navigate = useNavigate();
  const [clubRole, setClubRole] = useState("");

  const { teamId } = useParams();
  const { staffId } = useParams();
  const [roleDetails, setRoleDetails] = useState({});
  const [subRole, setSubRole] = useState([]);

  const calcSubRole = (role, subRole) => {
    if (!role || !subRole) return;
    let sub;
    if (role === "Treinador") {
      sub = config.MANAGER_SUB_ROLES.filter((el) => el.value === subRole);
      sub = sub; // for the coach we only accept 1 role
    } else if (role === "Director") {
      sub = config.POSITIONS_DIRECTOR.filter((el) =>
        subRole.includes(el.value)
      );
    } else {
      sub = config.POSITIONS_OTHER.filter((el) => subRole.includes(el.value));
    }

    setSubRole(sub);
  };

  useEffect(() => {
    async function fetchData() {
      if (!staffId) return;

      let account = await getAccount(staffId);

      setValue("name", account.attributes.name);
      setValue("email", account.attributes.users.data[0].attributes.email);

      setClubRole(account.attributes.role);

      setRoleDetails(
        Object.create({
          name: account.attributes.name,
          email: account.attributes.users.data[0].attributes.email,
          sub_role: account.attributes.sub_role,
        })
      );

      calcSubRole(account.attributes.role, account.attributes.sub_role);
    }

    fetchData();
  }, []);

  const submitForm = async (data) => {
    try {
      //Add validation for the role. It must not be null.
      if (!clubRole) {
        console.log("Please select a role before submiting the form");
      }

      let jogadorId = staffId;
      if (!staffId) {
        // if player id is not defined it means that the player already exists
        let respRegister = await registerAccount({...data, "password": 'fazfaz1234', 'repeatPass': "fazfaz1234"});
        jogadorId = respRegister.data.user.id;
      }

      let account = await getAccountByUserId(jogadorId);

      await putAccount(account.id, {
        ...roleDetails,
        role: clubRole,
        sub_role: subRole?.length ? subRole.map((el) => el.value) : [subRole],
        teams: [teamId],
      });

      if (roleDetails["history"] && roleDetails["history"].length) {
        for (let history of roleDetails["history"]) {
          await createTeamHistory({ account: account.id, ...history });
        }
      }

      toast.success("Staff foi adicionado com sucesso. Foi enviado um email para o email registado.");
      navigate(`/equipas/${teamId}`);
    } catch (exception) {
      console.log("Exception: ", exception);
    }
  };

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/equipas"}>Plantel</Link>/ Detalhe
              </ul>
            </nav>

            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">
                      {!staffId ? "Novo Staff" : "Editar staff"}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="columns">
              <div className="column">
                <form onSubmit={handleSubmit((data) => submitForm(data))}>
                  <div className="block">
                    <div className="field">
                      <label className="label">Email *</label>
                      <p className="control">
                        <input
                          className={`input ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          type="text"
                          disabled={!!staffId}
                          {...register("email", {
                            required: true,
                          })}
                          readOnly={staffId}
                          placeholder="exemplo@mail.com"
                        />
                      </p>
                      <p>{errors.email?.email}</p>
                    </div>

                    <div className="field">
                      <label className="label">Nome *</label>
                      <p className="control">
                        <input
                          className="input"
                          type="text"
                          disabled={!!staffId}
                          {...register("name", {
                            required: true,
                            minLength: 5,
                          })}
                          readOnly={staffId}
                          placeholder="Tiago Santos"
                        />
                      </p>
                    </div>

                    {!staffId && (
                      <>
                        <div className="field">
                          <label className="label">Zerozero link</label>
                          <div className="control">
                            <input
                              className="input"
                              type="text"
                              disabled={isReadOnly}
                              value={
                                roleDetails && roleDetails["zerozero_link"]
                                  ? roleDetails["zerozero_link"]
                                  : null
                              }
                              onChange={(event) => {
                                roleDetails["zerozero_link"] =
                                  event.target.value;
                                setRoleDetails(roleDetails);
                              }}
                              placeholder="https://www.zerozero.pt/coach.php?id=184"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="block">
                    <div className="field">
                      <label className="label">Cargo</label>
                      <Select
                        isDisabled={!!staffId}
                        value={config.STAFF_WITHIN_CLUB_ROLES.find(
                          (el) => el.value === clubRole
                        )}
                        onChange={(evt) => {
                          setClubRole(evt.value);
                          setSubRole([]);
                        }}
                        options={config.STAFF_WITHIN_CLUB_ROLES}
                      />
                    </div>
                    {clubRole === "Treinador" && (
                      <Manager
                        isReadOnly={!!staffId}
                        roleDetails={subRole}
                        calcSubRole={calcSubRole}
                      ></Manager>
                    )}
                    {clubRole === "Outro" && (
                      <Other
                        isReadOnly={!!staffId}
                        roleDetails={subRole}
                        calcSubRole={calcSubRole}
                      ></Other>
                    )}
                  </div>
                  {!staffId && (
                    <button className="button is-link is-footsolution">
                      Enviar
                    </button>
                  )}
                </form>
              </div>
            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
